import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import '../GetEvent.jsx/Event.css';
import useFormContext from "./useFormMarsComplete"
import * as L from "leaflet";
import { SITES_BASE_URL } from '../ApiDetails.js';
import { OpenStreetMapProvider } from 'leaflet-geosearch';

const EventMarsComplete = () => {
  const { eventFormData, setEventFormData,
    searchAddress, setSearchAddress,
    isEventOffSite, setIsEventOffSite
  } = useFormContext();

  const [mapMarker, setMapMarker] = useState(null);
  const leafLetMap = useRef(null);
  const isFirstRender = useRef(true);
  const storedRole = localStorage.getItem('role');

  var city = "";
  if (eventFormData.cityName != null) city = eventFormData.cityName;
  if (eventFormData.stateName != null) {
    city = city + (city != "" ? ", " : "") + eventFormData.stateName;
  }

  useEffect(() => {
    var u = window.location.href.split('/')[3];
    if (u !== 'getDetailMarsComplete') {
      if (isFirstRender.current) {
        loadInitMap();
      }
      isFirstRender.current = false;
    }

    if (eventFormData.siteCode === "OFF") {
      setSearchAddress(eventFormData.eventAddress);
    }
  }, [eventFormData]);

  useEffect(() => {
    if (eventFormData.siteCode) {
      setIsEventOffSite(eventFormData.siteCode === "OFF");
      if (eventFormData.siteCode === "OFF")
        fetchAddressCoordinates(eventFormData.eventAddress);
      else
        fetchCityCoordinates(eventFormData.siteCode);
    }
  }, [eventFormData.siteCode]);

  const loadInitMap = async () => {
    if (!leafLetMap.current) {
      leafLetMap.current = L.map(document.getElementById("MapID"));
      leafLetMap.current.invalidateSize();
    }

    L.tileLayer('http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}').addTo(leafLetMap.current);
  }

  const fetchCityCoordinates = async (siteCode) => {
    try {

      const response = await axios.get(`${SITES_BASE_URL}/${siteCode}`);

      // Check if the response contains valid data
      if (response.data) {
        const { latitude, longitude, unit, location, address, country, city } = response.data;

        if (!leafLetMap.current) {
          leafLetMap.current = L.map(document.getElementById("MapID"));
          leafLetMap.current.invalidateSize();
        }

        leafLetMap.current.setView([latitude, longitude], 14);
        L.tileLayer('http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}').addTo(leafLetMap.current);

        L.Icon.Default.mergeOptions({
          iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
          iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
          shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
        });

        if (mapMarker) leafLetMap.current.removeLayer(mapMarker);
        setMapMarker(null);
        var marker = L.marker([latitude, longitude]).addTo(leafLetMap.current);
        setMapMarker(marker);

        setEventFormData(prevData => ({
          ...prevData,
          eventVenueName: unit ?? prevData.eventVenueName,
          eventAddress: address ?? prevData.eventAddress,
          countryName: country ?? prevData.countryName,
          stateName: location ?? prevData.stateName,
          cityName: city ?? prevData.cityName,
          mltEvent: storedRole === "MLTUser" ? true : eventFormData.mltEvent
        }));
      } else {
        console.error("No data found for the specified site code.");
      }
    } catch (error) {
      console.error("Error fetching site coordinates:", error);
    }
  };

  const fetchAddressCoordinates = async (address) => {
    const provider = new OpenStreetMapProvider();
    const results = await provider.search({ query: address });
    if (mapMarker) leafLetMap.current.removeLayer(mapMarker);
    setMapMarker(null);
    if (!results[0]) {
      if (!leafLetMap.current) {
        leafLetMap.current = L.map(document.getElementById("MapID"));
        leafLetMap.current.invalidateSize();
      }
      leafLetMap.current.setView([0, 0], 14);
      return;
    }
    const latitude = results[0].y;
    const longitude = results[0].x;

    if (!leafLetMap.current) {
      leafLetMap.current = L.map(document.getElementById("MapID"));
      leafLetMap.current.invalidateSize();
    }

    leafLetMap.current.setView([latitude, longitude], 14);
    L.tileLayer('http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}').addTo(leafLetMap.current);

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
      iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
      shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
    });

    var marker = L.marker([latitude, longitude]).addTo(leafLetMap.current);
    setMapMarker(marker);
  };

  const content = (
    <>
      <div className="col-md-6">
        <div className=" bg-light rounded p-3 ">


          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              REQUESTED BY
            </label>
            <div className="col-sm-8 ">

              <input
                type="text"
                readOnly=""
                className="custom-font-lt form-control-plaintext disabled"
                id="requestedBy"
                name="requestedBy"
                value={eventFormData.requestedBy}
                placeholder="Not Applicable"
                autoComplete="off"
              />

            </div>
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              TITLE
            </label>
            <div className="col-sm-8 ">
              <input
                type="text"
                readOnly=""
                className="custom-font-lt form-control-plaintext disabled"
                id="staticEmail"
                name="eventTitle"
                value={eventFormData.eventTitle}
                placeholder="Not Applicable"
              />

            </div>
          </div>

          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label disabled"
            >
              E-MAIL
            </label>
            <div className="col-sm-8 ">
              <input
                type="text"
                readOnly=""
                className="custom-font-lt form-control-plaintext disabled"
                id="staticEmail"
                name="email"
                value={eventFormData.email}
              />
            </div>
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              PHONE
            </label>
            <div className="col-sm-8 ">
              <div className="row">
                <div className="col-3">
                  <input
                    type="text"
                    className="custom-font-lt form-control-plaintext disabled"
                    id="staticEmail"
                    name="phoneCode"
                    value={eventFormData.phoneCode}
                  />
                </div>
                <div className="col-9">
                  <input
                    type="number" onKeyDown={ (evt) => ((evt.key === 'e') ||(evt.key === 'E') ||(evt.key === '+') || (evt.key === '-') || (evt.key === '.')) && evt.preventDefault() }
                    className="custom-font-lt form-control-plaintext disabled"
                    id="staticEmail"
                    name="phone"
                    value={eventFormData.phone}
                    placeholder="Not Applicable"

                  />

                </div>
              </div>
            </div>
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              EVENT CO-HOST NAME <embed />
              Optional
              <embed />
            </label>
            <div className="col-sm-8 ">
              <input
                type="text"
                className="custom-font-lt form-control-plaintext disabled"
                id="staticEmail"
                name="eventCoHost"
                value={eventFormData.eventCoHost}
                //              placeholder={isEditing ? "" : "Enter a name"}
                autoComplete="off"
              />
            </div>
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              EVENT CO-HOST EMAIL <embed />
              Optional
              <embed />
            </label>
            <div className="col-sm-8 ">
              <input
                type="text"
                className="custom-font-lt form-control-plaintext disabled"
                id="staticEmail"
                name="coHostEmail"
                value={eventFormData.coHostEmail}
              //              placeholder="Enter an email"
              />
            </div>
          </div>
        </div>
        <div className=" bg-light rounded p-3 mt-3">
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              EVENT DATE
            </label>
            <div className="col-sm-8 d-flex align-items-center">
              <input
                type="input"
                className="custom-font-lt form-control-plaintext disabled me-2"
                name="eventDate"
                placeholder="Not Applicable"
                value={eventFormData.eventDate == '' ? '' : new Date(eventFormData.eventDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}
                style={{ "-webkit-calendar-picker-indicator": "100vh", width: "50%" }}
              />
              to
              <input
                type="input"
                className="custom-font-lt form-control-plaintext disabled ms-2"
                name="eventEndDate"
                placeholder="Not Applicable"
                value={eventFormData.eventEndDate == '' ? '' : new Date(eventFormData.eventEndDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}
                style={{ "-webkit-calendar-picker-indicator": "100vh", width: "100%" }}
              />
            </div>
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              IS THE EVENT DATE FLEXIBLE?
            </label>
            <div className="col-sm-8 ">
              <div className="custom-control custom-switch">
                <span className="custom-font-slider-left" style={{marginLeft:"10px"}}>NO</span>
                <input
                  type="hidden"
                  className="custom-control-input"
                  id="switch1"
                />
                <label className="switch">
                  <input type="checkbox" name="isDateFlexible"
                    checked={eventFormData.isDateFlexible || false}
                    disabled={eventFormData.eventStatus !== 'Draft'}
                  />
                  <span className="slider round" />
                </label>
                <span className="custom-font-slider-right">YES</span>
              </div>
            </div>
          </div>
        </div>
        <div className=" bg-light rounded p-3 mt-3">

          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >EXTERNAL EVENT</label>
            <div className="col-sm-8 ">
              <div className="custom-control custom-switch">
                <span className="custom-font-slider-left" style={{marginLeft:"10px"}}>NO</span>
                <input
                  type="hidden"
                  className="custom-control-input"
                  id="switch1"
                />
                <label className="switch">
                  <input type="checkbox" id="isOffSite"
                    checked={isEventOffSite}
                    disabled={true}
                  />
                  <span className="slider round" />
                </label>
                <span className="custom-font-slider-right">YES</span>
              </div>
            </div>
          </div>
          {(!isEventOffSite) && (
            <>
              <div className="form-group row mb-2">
                <label
                  htmlFor="staticEmail"
                  className="custom-font col-sm-4 col-form-label"
                >
                  AFFILIATED SITE CODE
                </label>
                <div className="col-sm-8 ">
                  <input
                    type="text"
                    className="custom-font-lt form-control-plaintext disabled"
                    id="staticSiteCode"
                    name="siteCode"
                    value={eventFormData.siteCode}
                    placeholder="Not Applicable"
                  />

                </div>
              </div>

              <div className="form-group row mb-2">
                <label
                  htmlFor="staticEmail"
                  className="custom-font col-sm-4 col-form-label"
                >
                  COUNTRY
                </label>
                <div className="col-sm-8 ">
                  <input
                    className="custom-font-lt form-control-plaintext disabled"
                    aria-label="Small select example"
                    name="countryName"
                    value={eventFormData.countryName}
                  />
                </div>
              </div>
              <div className="form-group row mb-2">
                <label
                  htmlFor="staticEmail"
                  className="custom-font col-sm-4 col-form-label"
                >
                  STATE
                </label>
                <div className="col-sm-8 ">
                  <input
                    className="custom-font-lt form-control-plaintext disabled"
                    aria-label="Small select example"
                    name="stateName"
                    value={eventFormData.stateName}
                  />
                </div>
              </div>
              <div className="form-group row mb-2">
                <label
                  htmlFor="staticEmail"
                  className="custom-font col-sm-4 col-form-label"
                >
                  CITY
                </label>
                <div className="col-sm-8 ">
                  <input
                    className="custom-font-lt form-control-plaintext disabled"
                    aria-label="Small select example"
                    name="cityName"
                    value={eventFormData.cityName}
                  />
                </div>
              </div>
              <div className="form-group row mb-2">
                <label
                  htmlFor="staticEmail"
                  className="custom-font col-sm-4 col-form-label"
                >
                  EVENT VENUE NAME
                </label>
                <div className="col-sm-8 ">
                  <input
                    type="text"
                    className="custom-font-lt form-control-plaintext disabled"
                    id="staticEmail"

                    name="eventVenueName"
                    value={eventFormData.eventVenueName}
                  />

                </div>
              </div>
            </>
          )}
          {(!isEventOffSite) && (
            <>
              <div className="form-group row mb-2">
                <label
                  htmlFor="staticEmail"
                  className="custom-font col-sm-4 col-form-label"
                >
                  EVENT VENUE ADDRESS
                </label>
                <div className="col-sm-8 ">
                  <input
                    type="text"
                    className="custom-font-lt form-control-plaintext disabled"
                    id="staticEmail"
                    name="eventAddress"
                    value={eventFormData.eventAddress}
                  />

                </div>
              </div>
            </>
          )}
          {(isEventOffSite) && (
            <>
              <div className="form-group row mb-2">
                <label
                  htmlFor="staticEmail"
                  className="custom-font col-sm-4 col-form-label"
                >
                  EXTERNAL EVENT ADDRESS
                </label>
                <div className="col-sm-8 ">
                  <textarea
                    className="custom-font-lt form-control disabled"
                    id="searchAddress"
                    name="searchAddress"
                    rows="5"
                    value={searchAddress}
                    disabled={true}
                  />
                </div>
              </div>
            </>
          )}
        </div>
        <div className=" bg-light rounded p-3 mt-3">

          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              EVENT TYPE
            </label>
            <div className="col-sm-8 " >
              <input
                className="custom-font-lt form-control-plaintext disabled"
                aria-label="Small select example"
                name="eventType"
                value={eventFormData.eventType}
              />


            </div>
          </div>
          {(eventFormData.eventType === "Other") && (
            <div className="form-group row mb-2" id="otherEventTypeDiv">
              <label
                htmlFor="staticEmail"
                className="border-custom-strip custom-font col-sm-4 col-form-label"
              >
                <div className="" />
                SPECIFICATION
              </label>
              <div className="col-sm-8  ">
                <input
                  readOnly={true}
                  type="text"
                  className="custom-font-lt form-control-plaintext disabled"
                  id="staticEmail"
                  name="otherEventType"
                  value={eventFormData.otherEventType}
                />
              </div>
            </div>
          )}
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              EVENT FORMAT
            </label>
            <div className="col-sm-8 ">
              <input
                className="custom-font-lt form-control-plaintext disabled"
                aria-label="Small select example"
                name="eventFormat"
                value={eventFormData.eventFormat}
              />
            </div>
          </div>
          {(eventFormData.eventFormat === "Other") && (
            <div className="form-group row mb-2" id="otherEventFormatDiv">
              <label
                htmlFor="staticEmail"
                className="border-custom-strip custom-font col-sm-4 col-form-label"
              >
                <div className="" />
                SPECIFICATION
              </label>
              <div className="col-sm-8  ">
                <input
                  readOnly={true}
                  type="text"
                  className="custom-font-lt form-control-plaintext disabled"
                  id="staticEmail"
                  name="otherEventFormat"
                  value={eventFormData.otherEventFormat}
                />
              </div>
            </div>
          )}
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              LAST FAMILY MEMBER VISIT
            </label>
            <div className="col-sm-8 ">
              <input
                className="custom-font-lt form-control-plaintext disabled"
                aria-label="Small select example"
                name="lastVisit"
                value={eventFormData.lastVisit}
              />



            </div>
          </div>

        </div>
        <div className=" bg-light rounded p-3 mt-3 mb-3">

          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              ASSOCIATE(S) EXPECTED AT EVENT
            </label>
            <div className="col-sm-8 " id="AssoInput">
              <input
                className="custom-font-lt form-control-plaintext disabled"
                aria-label="Small select example"
                name="lastVisit"
                rows="7"
                value={eventFormData.associates}
              />
            </div>
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              ESTIMATED TOTAL NUMBER OF ATTENDEES (NUMBERS ONLY)
            </label>
            <div className="col-sm-8 ">
              <input
                readOnly=""
                type="number" onKeyDown={ (evt) => ((evt.key === 'e') ||(evt.key === 'E') ||(evt.key === '+') || (evt.key === '-') || (evt.key === '.')) && evt.preventDefault() }
                className="custom-font-lt form-control-plaintext disabled"
                id="staticEmail"
                name="totalAttendees"
                value={eventFormData.totalAttendees}
                placeholder="Not Applicable"
              />

            </div>
          </div>
        </div>

      </div>
      <div className="col-md-4 rounded " style={{pointerEvents:"none"}} id="MapID">
      </div>
      <div style={{ height: "100px" }}></div>
    </>
  );

  return content
}


export default EventMarsComplete;








